import {
  Document,
  Image,
  Page,
  PDFViewer,
  Text,
  View,
} from "@react-pdf/renderer";
import dayjs from "dayjs";
import React, { useState } from "react";
import { Request } from "../../hooks/Request";
import { validateArray } from "../../utils/validate";
import { generateQRBase64 } from "../../utils/utils";

const s = {
  page: {
    padding: "80px 65px 0 60px",
    fontFamily: "Helvetica",
    fontSize: 11,
  },
  cell: { paddingVertical: 2, paddingHorizontal: 3 },
  bold: { fontFamily: "Helvetica-Bold" },
  italicBold: { fontFamily: "Helvetica-BoldOblique" },
  row: { display: "flex", flexDirection: "row", gap: 4 },
  col: { display: "flex", flexDirection: "column", gap: 4 },
  header: {
    position: "absolute",
    top: "0",
    left: "0",
    zIndex: -10,
  },
  footer: {
    position: "absolute",
    bottom: 0.1,
    left: 0,
    zIndex: -10,
  },
  watterMark: {
    position: "absolute",
    zIndex: -10,
    top: "50%",
    left: "50%",
  },
  border: { borderWidth: 1 },
  line: {
    flex: 1,
    borderBottomWidth: 2.4,
    borderBottomColor: "black",
    marginHorizontal: 5,
  },
  styleFormat: {
    position: "absolute",
    top: "0",
    left: "0",
    zIndex: -10,
    width: "612px",
    height: "792px",
  },
  w10: { width: "10%" },
  w18: { width: "18%" },
  w19: { width: "19%" },
  w20: { width: "20%" },
  w24: { width: "24%" },
  w28: { width: "28%" },
  w40: { width: "40%" },
  w45: { width: "45%" },
  w50: { width: "50%" },
  w55: { width: "55%" },
  w60: { width: "60%" },
  w65: { width: "65%" },
  w70: { width: "70%" },
  w75: { width: "75%" },
  w80: { width: "80%" },
  w85: { width: "85%" },
  w90: { width: "90%" },
  w95: { width: "95%" },
  w100: { width: "100%" },
};

const listFields = [
  "entregaDeDocumentos",
  "codigoDeInterno",
  "modalidadDeDespacho",
  "descripciónDeLaMercancía",
  "partidaArancelaria",
  "a1NúmeroDeDeclaración",
  "adjuntarDim",
  "canal(Rojo,AmarilloOVerde)",
];

export const DeliveryOfDocumentsPDF = (props) => {
  const { procedure } = props;
  const { data, loading } = Request({
    urlApi: `/Procedure/${
      procedure.id || procedure.procedureId
    }/dataValues?${listFields.map((field) => `fieldnames=${field}`).join("&")}`,
  });
  const [QR, setQR] = useState("");

  const { data: dataList, loading: loadingList } = Request({
    urlApi: `/dataSet/procedure/${
      procedure.id || procedure.procedureId
    }/field/589/subdata`,
  });

  const transformTextToQR = async (value) => {
    const url = await generateQRBase64(value);
    setQR(url);
  };

  if (!loading || !loadingList) {
    return null;
  }

  dayjs.locale("es");
  transformTextToQR(data.adjuntarDim ?? "No se encontro el Enlace");

  const MyDoc = () => {
    const RenderCustomTable = ({ columns, data }) => {
      return (
        <>
          {/* Encabezados de columna */}
          <View style={[s.row, { borderBottomWidth: 1 }]}>
            {columns.map((col, colIndex) => (
              <Text
                key={colIndex}
                style={[
                  s.bold,
                  {
                    width: `${col.width}%`,
                    paddingHorizontal: 5,
                    paddingVertical: 3,
                    textAlign: colIndex > 1 ? "center" : "left",
                  },
                ]}
              >
                {col.label}
              </Text>
            ))}
          </View>

          {/* Filas de datos */}
          {data.map((item, index) => (
            <View key={index} style={[s.row]}>
              {columns.map((col, colIndex) => (
                <Text
                  key={colIndex}
                  style={{
                    width: `${col.width}%`,
                    paddingHorizontal: 5,
                    paddingVertical: 3,
                  }}
                >
                  {item[col.name]}
                </Text>
              ))}
            </View>
          ))}
        </>
      );
    };

    return (
      <Document>
        <Page size={"LETTER"} style={[s.page, { position: "relative" }]}>
          {/* FORMATO */}
          <View style={s.styleFormat}>
            <Image
              src="https://res.cloudinary.com/joeldes/image/upload/v1751556894/DeliveryDay/reports/DD_formato-informe_xdmzwo.jpg"
              style={{ width: "100%", height: "100%" }}
            />
          </View>

          {/* Fecha y codigo */}
          <View
            style={[
              s.col,
              {
                gap: 2,
                alignItems: "flex-end",
                paddingTop: 20,
                paddingBottom: 50,
              },
            ]}
          >
            <Text style={s.bold}>APLICACIÓN N° {data.codigoDeInterno}</Text>
            <Text>{`La Paz, ${dayjs().format("D [de] MMMM [de] YYYY")}`}</Text>
          </View>

          {/* Dirigido a */}
          <View style={[s.col, { paddingBottom: 20 }]}>
            <Text>Señores:</Text>
            <Text style={s.bold}>{data.company.razonSocial}</Text>
            <Text style={s.bold}>Celular: {data.company.phone ?? "-"}</Text>
            <Text style={s.bold}>Correo: {data.company.email ?? "-"}</Text>
            <Text>Presente.-</Text>
          </View>

          {/* Titulo */}
          <View style={{ textAlign: "right", paddingBottom: 20 }}>
            <Text>
              REF.:
              <Text style={[s.bold, { textDecoration: "underline" }]}>
                ENTREGA DE DOCUMENTOS
              </Text>
            </Text>
          </View>

          {/* Info */}
          <View style={[s.col, { gap: 8, paddingBottom: 15, lineHeight: 1.5 }]}>
            <Text>De nuestra mayor consideración:</Text>
            <Text>
              Adjunto a la presente, documentos correspondientes al despacho
              aduanero, efectuado con la Declaración de Mercancías de
              Importación {data.a1NúmeroDeDeclaración ?? ""} conforme al
              siguiente:
            </Text>
          </View>

          <View
            style={{
              borderTopWidth: 1,
              borderBottomWidth: 1,
              fontSize: 8,
              marginBottom: 6,
            }}
          >
            <RenderCustomTable
              columns={[
                { name: "document", label: "Documento", width: 40 },
                { name: "number", label: "Número", width: 50 },
                { name: "type", label: "Tipo", width: 10 },
              ]}
              data={
                dataList && validateArray(dataList)
                  ? dataList.map((item) => {
                      return {
                        document: item.label,
                        number: item.description,
                        type: item.description2,
                      };
                    })
                  : []
              }
            />
          </View>
          {/* Mensaje de despedida */}
          <View style={[s.col, { gap: 3 }]}>
            {/* Canal verde */}
            {data["canal(Rojo,AmarilloOVerde)"] === "Canal Verde" ? (
              <Text style={[s.italicBold, { lineHeight: 1.5, fontSize: 9 }]}>
                SE ADJUNTA UN LEGAJO DE LEGALIZADAS PARA FUTURAS VERIFICACIONES
                POR LA ADUANA NACIONAL
              </Text>
            ) : null}
            {/* Imagen del QR */}
            <View style={[s.col, { alignItems: "center" }]}>
              <Image src={QR} style={{ width: 100, height: 100 }} />
            </View>
            {/* Canal rojo */}
            <Text style={{ lineHeight: 1.5 }}>
              Para tener acceso a la documentación soporte conforme ART. 111 del
              reglamento a la ley general de aduanas D.S. 25870. Proceder al
              escaneo del presente QR.
            </Text>
            <Text style={{ lineHeight: 1.5 }}>
              Con este motivo y esperando brindarle nuestros servicios en una
              próxima oportunidad, reciba un cordial saludo.{" "}
            </Text>
            <Text style={[{ fontSize: 9 }]}>Cc/arch.</Text>
            <Text style={[s.bold, { fontSize: 9 }]}>Adj. Lo citado</Text>
          </View>
        </Page>
      </Document>
    );
  };

  return (
    <div>
      <PDFViewer
        style={{
          width: 900,
          height: window.innerHeight - 100,
        }}
      >
        <MyDoc />
      </PDFViewer>
    </div>
  );
};
